// ISO timestamp → KST 표시 헬퍼 (자정 근처 UTC slice 1일 차이 사고 방지)
//
// 백엔드 arrived_at 은 ISO UTC timestamp ('2026-05-02T15:30:00.000Z').
// 단순 slice(0,10) 은 UTC 날짜 → KST 자정 근처 1일 차이 가능.
//   예: 2026-05-03 00:30 KST = 2026-05-02 15:30 UTC
//   slice(0,10) → '2026-05-02' (잘못)
//   formatArrivedAtKstDate → '2026-05-03' (정확)

// 'YYYY-MM-DD HH:MM' (KST)
export function formatArrivedAtKst(iso) {
  if (!iso) return '';
  try {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    var kst = new Date(d.getTime() + 9 * 3600 * 1000);
    return kst.toISOString().slice(0, 10) + ' ' + kst.toISOString().slice(11, 16);
  } catch (e) { return iso; }
}

// 'YYYY-MM-DD' (KST 날짜만 — 차량 목록 압축 표시용)
export function formatArrivedAtKstDate(iso) {
  if (!iso) return '';
  try {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    var kst = new Date(d.getTime() + 9 * 3600 * 1000);
    return kst.toISOString().slice(0, 10);
  } catch (e) { return iso; }
}
